define('body',['even'], function (Even) {

	/*
	 * Maneja la inserción o eliminación de las clases CSS que proveen una 'bonitas'
	 * transiciones a la página después de cargar los datos.
	**/
	return Backbone.View.extend({

		initialize: function initialize() {
			this.on('UI.mainViewPending', this.setPending, this);
			this.on('UI.mainViewReady', this.setReady, this);
		},

		/*
		 * Esperando por datos.
		**/
		setPending: function setPending() {
			this
				.$el
				.removeClass('content-ready')
				.addClass('request-pending');
		},

		/*
		 * Manejando el arrivo de nuevos datos.
		**/
		setReady: function setReady(section) {
			//-- 
			// console.log(this.$el.attr('class'));
			// console.log(section);
			//-- 
			this.$el
				.removeClass('request-pending')
				.addClass('content-inserted');

			_.delay(function (that) {
				that
					.$el
					.addClass('content-ready');
			}, 100, this);

			_.delay(function (that) {
				that
					.$el
					.removeClass('content-inserted');


			// }, 900, this);
			}, 200, this);

		}

	});

});
